import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import {  deletePaymentCoupon } from '../../../../../../../../crud/payments_api/payment_coupons';

import { toast } from 'react-toastify';
import { X } from 'react-bootstrap-icons';


interface RenderDeleteCouponsModalProps {
  show: boolean;
  handleClose: () => void;
  couponsToDelete: any[];     // o define tu propia interfaz Coupon
  setCoupons: any;            // o más exactamente: React.Dispatch<React.SetStateAction<any[]>>
}



const DeleteCoupon: React.FC<RenderDeleteCouponsModalProps> = ({
  show,
  handleClose,
  couponsToDelete,
  setCoupons,
}) => {

  const handleDelete = async () => {
    try {
      // Eliminar cada cupón seleccionado
      for (const coupon of couponsToDelete) {
        await deletePaymentCoupon(coupon.payment_coupon_id);
        toast.success(`Cupón "${coupon.payment_coupon_name}" eliminado exitosamente.`);
      }
      // Filtrar de la lista los cupones ya borrados
      setCoupons((prevCoupons: any[]) =>
        prevCoupons.filter((c: any) =>
          !couponsToDelete.some((del: any) => del.payment_coupon_id === c.payment_coupon_id)
        )
      );
      handleClose();
    } catch (error) {
      console.error('Error al eliminar cupones:', error);
      toast.error('Ocurrió un error al eliminar los cupones.');
    }
  };

  return (
    <Modal show={show} onHide={handleClose} className='modal-cupones'>
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Eliminar cupón</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        {couponsToDelete.length === 0 ? (
          <p>No hay cupones para eliminar.</p>
        ) : couponsToDelete.length > 1 ? (
          <p>
            ¿Estás seguro de que deseas eliminar los {couponsToDelete.length} cupones seleccionados?
            Esta acción no se puede deshacer.
          </p>
        ) : (
          <p>
            ¿Estás seguro de que deseas eliminar el cupón
            <strong> "{couponsToDelete[0].payment_coupon_name}"</strong>?
            Esta acción no se puede deshacer.
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button className="form-button-cancel" variant='none' onClick={handleClose}>
            Cancelar
          </Button>
          {couponsToDelete.length > 0 && (
            <Button className="form-button-delete" onClick={handleDelete} variant="danger">
              Eliminar
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCoupon;